// Ameen homepage hero, fall season: "Five clouds" (snippets/ameen-fall-clouds.liquid).
// The jars start closed. Scrolling through the hero's runway (it is taller than the screen and
// its content sticks) opens them in turn: each lid pops off, then that blend bursts up out of the
// open jar as a cloud. Everything is a pure function of one progress value p (0 = closed,
// 1 = all five open), so scrolling back closes them again. Dust is only drawn while p is moving.
(function(){
  var root = document.querySelector('[data-fc]');
  if(!root) return;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var hero = root.closest('.hero') || root;
  var hint = hero.querySelector('[data-fc-hint]');
  var canvas = root.querySelector('[data-fc-dust]');
  var ctx = canvas && canvas.getContext('2d');
  var small = window.matchMedia('(max-width:760px)').matches;
  var PER = small ? 110 : 240;                 // grains per cloud
  var LID = .203;                              // lid line, as a fraction of the jar's height (see --lid)
  var WHOLE = ['#6b3a1c', '#8a4a26', '#3d2414', '#d8782a', '#8b8f4a', '#a0522d'];  // bark, berries, peel, cardamom

  function clamp(v){ return v < 0 ? 0 : v > 1 ? 1 : v; }
  function smooth(t){ return t * t * (3 - 2 * t); }
  function outCubic(t){ return 1 - Math.pow(1 - t, 3); }
  function rgb(hex, k){
    var n = parseInt(hex.replace('#', ''), 16);
    return 'rgb(' + Math.min(255, ((n >> 16) & 255) * k | 0) + ',' + Math.min(255, ((n >> 8) & 255) * k | 0) + ',' + Math.min(255, (n & 255) * k | 0) + ')';
  }

  // Each grain keeps where it settles in the cloud (u across, v up), when it leaves the jar (d) and its look.
  var C = [].slice.call(root.querySelectorAll('[data-fc-col]')).map(function(el){
    var whole = el.getAttribute('data-kind') === 'whole', tint = el.getAttribute('data-tint') || '#c9692c', parts = [];
    for(var j = 0; j < PER; j++){
      parts.push({
        v: Math.pow(Math.random(), .8),
        u: (Math.random() + Math.random() + Math.random() - 1.5) / 1.5,
        d: Math.random() * .42,
        s: whole && Math.random() < .3 ? 2.6 + Math.random() * 2.8 : .8 + Math.random() * 1.7,
        w: Math.random() * 6.283,
        c: whole ? WHOLE[(Math.random() * WHOLE.length) | 0] : rgb(tint, .7 + Math.random() * .6)
      });
    }
    return {
      plume: el.querySelector('.fc__plume'), jar: el.querySelector('.fc__jar'),
      lid: el.querySelector('.fc__lid'), mouth: el.querySelector('.fc__mouth'),
      parts: parts, q: 1, mx: 0, my: 0, pw: 0, ph: 0
    };
  });
  if(!C.length || !ctx) return;

  /* ---- Geometry: the open mouth (the lid line) is where every grain leaves from ---- */
  var W = 0, H = 0, DPR = Math.min(window.devicePixelRatio || 1, 2), runway = 0;
  function measure(){
    var r = root.getBoundingClientRect();
    W = r.width; H = r.height;
    canvas.width = Math.round(W * DPR); canvas.height = Math.round(H * DPR);
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    C.forEach(function(c){
      var j = c.jar.getBoundingClientRect();
      c.mx = j.left - r.left + j.width / 2;
      c.my = j.top - r.top + j.height * LID;
      c.pw = (c.plume ? c.plume.offsetWidth : j.width * 1.5) * .6;    // the cloud fills the middle 60% of its photo
      c.ph = (c.plume ? c.plume.offsetHeight : j.width * 2.2) * .95;
    });
    runway = hero.offsetHeight - window.innerHeight;
    render();
  }

  /* ---- One frame at progress p ---- */
  var p = 0;
  function render(){
    ctx.clearRect(0, 0, W, H);
    if(hint) hint.style.opacity = (1 - clamp(p * 6)).toFixed(3);
    for(var i = 0; i < C.length; i++){
      var c = C[i];
      // The lid twists up and away first...
      var lt = clamp((p - .02 - i * .06) / .16), le = smooth(lt);
      if(c.lid){
        c.lid.style.transform = lt > 0 ? 'translate(' + (-14 * le).toFixed(2) + '%,' + (-26 * le).toFixed(2) + '%) rotate(' + (-32 * le).toFixed(2) + 'deg)' : '';
        c.lid.style.opacity = (1 - clamp((lt - .55) / .45)).toFixed(3);
      }
      if(c.mouth) c.mouth.style.opacity = clamp(lt * 1.6).toFixed(3);
      // ...then the blend bursts out of the open jar: q = 1 is still inside, 0 is the cloud standing.
      c.q = 1 - outCubic(clamp((p - .14 - i * .06) / .42));
      var q = c.q;
      if(c.plume){
        c.plume.style.opacity = (1 - q * q).toFixed(3);
        c.plume.style.transform = q > 0 ? 'scale(' + (1 - .4 * q).toFixed(3) + ',' + (1 - .86 * q).toFixed(3) + ')' : '';
      }
      if(q <= 0 || q >= 1) continue;
      for(var k = 0; k < c.parts.length; k++){
        var g = c.parts[k], t = clamp((q - g.d) / .55);
        if(t <= 0 || t >= 1) continue;
        var e = smooth(t);
        var sx = c.mx + g.u * (c.pw * .14 + c.pw * .5 * g.v), sy = c.my - g.v * c.ph;
        var x = sx + (c.mx - sx) * e + Math.sin(g.w + t * 5) * 4 * (1 - t);
        var y = sy + (c.my - sy) * e;
        ctx.globalAlpha = Math.sin(Math.PI * t) * .9;
        ctx.fillStyle = g.c;
        ctx.fillRect(x - g.s / 2, y - g.s / 2, g.s, g.s);
      }
    }
    ctx.globalAlpha = 1;
  }

  var raf = 0;
  function frame(){ raf = 0; render(); }
  function set(v){ v = clamp(v); if(v === p) return; p = v; if(!raf) raf = requestAnimationFrame(frame); }

  /* ---- Scroll drives p through the runway. Without a runway (no overflow:clip support),
     the jars open by themselves shortly after load instead. ---- */
  function onScroll(){ if(runway > 40) set(-hero.getBoundingClientRect().top / runway); }
  function autoplay(){
    var t0 = 0;
    (function step(now){
      if(!t0) t0 = now;
      set((now - t0 - 900) / 2600);
      if(p < 1) requestAnimationFrame(step);
    })(performance.now());
  }

  function start(){
    measure();
    if(runway > 40){ window.addEventListener('scroll', onScroll, {passive:true}); onScroll(); }
    else autoplay();
    if(window.ResizeObserver) new ResizeObserver(measure).observe(root); else window.addEventListener('resize', measure);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
